import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Graph, IndicatorsPf } from '../../models/itens.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-itens-pf-indicators',
  templateUrl: './itens-pf-indicators.component.html',
  styleUrls: ['./itens-pf-indicators.component.scss','../itens-edit/itens-edit.component.scss']
})
export class ItensPfIndicatorsComponent extends BaseFormComponent<IndicatorsPf> implements OnInit {
  @Input() parentFormGroup: FormGroup = null;
  @Input() expand: boolean = true;
  @Input() currentItem: object[] = [];
  @Output() checkStatus = new EventEmitter<boolean>();
  status = {'0':'Sem informação','1':'Igual ou superior a 90.00','2':'Entre 70.00 e 90.00','3':'Abaixo de 70.00'};
  analysis = {'0':'Sem Meta','1':'Atingir a meta',
    '2':'Algumas dificuldades para atingir a meta',
    '3':'Pouco provável que a meta seja atingida'};
  polar= {'1':'Se maior, melhor', '3':'Se menor, melhor'};
  constructor(
    public activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
  ) { 
    super(activatedRoute);
  }
  
  ngOnInit() {
  }

  generateLink(item){
    return 'projetos/projeto/' + this.parentFormGroup.get('id').value + '/indicadores/' + item.id;
  }
  
  get pfIndicators(): FormArray {
    return this.parentFormGroup.get('pfIndicators') as FormArray;
  }
  
  getIndFormArray(id:number){
    return this.pfIndicators.controls[id]?.get('actions') as FormArray;
  }

  onCheckStatus(itemForm:FormGroup = null) {
    if(itemForm != null){
      const criticalsArray = itemForm.get('criticals') as FormArray;
      if(criticalsArray.controls.length > 0){
        criticalsArray.controls.forEach(control => {
          control.patchValue({ checkeds: itemForm.value['checkeds'] });
        });
        const anyChecked = itemForm.get('criticals').value.some(it => it.checkeds === true);
        itemForm.get("checkeds").setValue(anyChecked ?? false);
      }
    }
    this.checkStatus.emit(true);
  }
  getCurrentMonth(data){
    var currentMonth = null;
    if (data['current_month']) {
      currentMonth = data['current_month'];
    } else {
        if (data['period_mod_id'] == 1 || data['period_mod_id'] == 2) {
            currentMonth = data['month1'];
        } else {
            currentMonth = 1;
        }
    }
    return this.sharedService.getMonth(data, currentMonth);
  }
   getGraph(variable) {
    return this.sharedService.getGraph(variable);
  }
  
}
